import { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { App, Button, Card, Form, Input, Typography } from "antd";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

type LoginForm = {
  username: string;
  password: string;
};

export function LoginPage() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate replace to="/" />;

  const submit = async (values: LoginForm) => {
    setLoading(true);
    try {
      await login(values.username, values.password);
      message.success("登录成功");
      navigate("/", { replace: true });
    } catch (error) {
      message.error(error instanceof Error ? error.message : "登录失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-visual">
        <div className="login-wordmark">KABEL</div>
        <div>
          <Typography.Title>Content, clearly managed.</Typography.Title>
          <Typography.Paragraph>
            从页面封面到每一篇文章、每一个产品，集中维护官网全部内容。
          </Typography.Paragraph>
        </div>
      </div>
      <div className="login-panel">
        <Card className="login-card" variant="borderless">
          <div className="login-brand">
            <span className="login-brand-mark">K</span>
            <div>
              <Typography.Title level={3}>KABEL Admin</Typography.Title>
              <Typography.Text type="secondary">
                使用管理员账号登录
              </Typography.Text>
            </div>
          </div>
          <Form<LoginForm>
            initialValues={{ username: "admin", password: "admin123" }}
            layout="vertical"
            onFinish={submit}
            requiredMark={false}
            size="large"
          >
            <Form.Item
              label="账号"
              name="username"
              rules={[{ required: true, message: "请输入账号" }]}
            >
              <Input autoComplete="username" prefix={<UserOutlined />} />
            </Form.Item>
            <Form.Item
              label="密码"
              name="password"
              rules={[{ required: true, message: "请输入密码" }]}
            >
              <Input.Password
                autoComplete="current-password"
                prefix={<LockOutlined />}
              />
            </Form.Item>
            <Button block htmlType="submit" loading={loading} type="primary">
              登录
            </Button>
          </Form>
          <Typography.Text className="login-hint" type="secondary">
            默认账号：admin / 密码：admin123
          </Typography.Text>
        </Card>
      </div>
    </main>
  );
}
